<template>
  <div v-if="extra?.onu?.deregistered">
    <span class="text-danger">{{extra?.onu?.deregistered}}</span>
    <br/>
    Отключено с {{common.fromUnixtime(extra?.onu?.["dereg-from"])}}
  </div>
  <div v-else-if="extra?.onu?._empty"></div>
  <table class="table table-striped" v-else>
    <thead>
      <tr><th/><th/></tr>
    </thead>
    <tbody>
      <tr v-for="attr in ['vendor','model','mac','temperature','olt_rx','onu_rx','onu_tx']">
        <td>{{attr}}</td>
        <td v-if="attr=='mac'">{{common.formatMac(extra.onu?.[attr])}}</td>
        <td v-else-if="attr=='temperature'">{{extra.onu?.[attr]}}&deg;</td>
        <td v-else-if="['olt_rx', 'onu_rx', 'onu_tx'].includes(attr)">{{extra.onu?.[attr]}} dBm</td>
        <td v-else>{{extra.onu?.[attr]}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "PonTreeOnu",
  
  props: {
    state: Object,
    extra: Object,
  },

}
</script>

<style scoped>
.text-danger 
{
  font-size: larger;
}
</style>